import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  fieldValue: {
    display: 'flex',
    flexDirection: 'column',

    '& .__fieldValueLabel': {
      color: 'var(--color-neutral-700)'
    },
    '& .__fieldValueValue': {
      color: 'var(--text-color-main)',
      padding: '.5rem'
    }
  }
}))

const FieldValue = ({ label, children }) => {
  const classes = useStyles()

  return (
    <div className={classes.fieldValue}>
      <label className='__fieldValueLabel'>{label}</label>
      <div className='__fieldValueValue'>{children}</div>
    </div>
  )
}

FieldValue.propTypes = {
  label: PropTypes.string,
  children: PropTypes.any
}

export default FieldValue
